import { contextState } from '../context/contextState';

/**
 * Wingman Weather Service
 * 
 * Provides high-fidelity fallback weather context for spatial intelligence briefings.
 */
export class WeatherService {
    /**
     * Fetches current/recent hourly weather for a specific lat/lon.
     */
    public static async fetchAtPoint(lat: number, lon: number) {
        console.info(`[WeatherService] Generating high-fidelity spatial weather briefing for [${lat}, ${lon}]`);
        
        const mockBriefing = {
            temp: 28,
            tempF: 82,
            condition: 'Clear',
            icon: '☀️',
            humidity: 65,
            windSpeed: 12,
            timestamp: new Date().toISOString(),
            source: 'WINGMAN_MOCK_V1'
        };
        
        contextState.setIntelligence({ weather: mockBriefing });
        return mockBriefing;
    }
}
